import { distance3 } from './math.js';

export const COURSE = Object.freeze([
  { x: 0, y: 95, z: -1050, radius: 34, label: 'Departure gate' },
  { x: -260, y: 150, z: -2050, radius: 36, label: 'Pine ridge' },
  { x: 240, y: 210, z: -3100, radius: 38, label: 'Eagle bend' },
  { x: 650, y: 260, z: -4200, radius: 40, label: 'Granite pass' },
  { x: 140, y: 205, z: -5400, radius: 38, label: 'Lake crossing' },
  { x: -570, y: 165, z: -6500, radius: 36, label: 'Falcon turn' },
  { x: -180, y: 120, z: -7700, radius: 34, label: 'Valley run' },
  { x: 370, y: 90, z: -8850, radius: 32, label: 'Coastal gate' },
  { x: 100, y: 62, z: -10100, radius: 31, label: 'Approach entry' },
  { x: 0, y: 38, z: -11500, radius: 29, label: 'Final approach' }
]);

export function createMissionState() {
  return {
    phase: 'preflight',
    activeRing: 0,
    score: 0,
    elapsed: 0,
    rings: 0,
    nearMisses: 0,
    message: 'Start the engine',
    result: null
  };
}

export function startMission(mission) {
  mission.phase = 'takeoff';
  mission.message = 'Full throttle. Rotate above 100 knots.';
  return mission;
}

export function awardBirdEvent(mission, event) {
  if (event === 'near-miss') {
    mission.nearMisses += 1;
    mission.score += 250;
    mission.message = 'Bird near miss +250';
  } else if (event === 'strike') {
    mission.score = Math.max(0, mission.score - 400);
    mission.message = 'Bird strike -400';
  }
}

export function updateMission(mission, flight, dt) {
  if (['preflight', 'complete', 'crashed'].includes(mission.phase)) return null;
  mission.elapsed += dt;

  if (flight.crashed) {
    mission.phase = 'crashed';
    mission.message = 'Aircraft lost';
    mission.result = { score: mission.score, success: false };
    return { type: 'crash' };
  }

  if (mission.phase === 'takeoff' && !flight.grounded && flight.position.y > 24) {
    mission.phase = 'course';
    mission.message = `Gate 1 · ${COURSE[0].label}`;
    mission.score += 300;
    return { type: 'takeoff', points: 300 };
  }

  if (mission.phase === 'course') {
    const ring = COURSE[mission.activeRing];
    if (ring && distance3(flight.position, ring) <= ring.radius * 0.72) {
      const precision = Math.round(Math.max(0, 220 - distance3(flight.position, ring) * 6));
      const speedBonus = Math.round(Math.min(180, Math.max(0, flight.speed - 42) * 2));
      const points = 600 + precision + speedBonus;
      mission.score += points;
      mission.rings += 1;
      mission.activeRing += 1;

      if (mission.activeRing >= COURSE.length) {
        mission.phase = 'approach';
        mission.message = 'Course complete. Land on runway 27.';
      } else {
        mission.message = `Gate ${mission.activeRing + 1} · ${COURSE[mission.activeRing].label}`;
      }
      return { type: 'ring', index: mission.activeRing - 1, points };
    }
  }

  if (mission.phase === 'approach' && flight.touchdown) {
    const validRunway = flight.touchdown.runwayId === 'landing';
    if (flight.touchdown.safe && validRunway) {
      const softLanding = Math.round(Math.max(0, 900 + flight.touchdown.sinkRate * 80));
      const timeBonus = Math.round(Math.max(0, 3000 - mission.elapsed * 6));
      const points = 1500 + softLanding + timeBonus;
      mission.score += points;
      mission.phase = 'complete';
      mission.message = 'Mission complete';
      mission.result = {
        score: mission.score,
        success: true,
        landingBonus: points,
        elapsed: mission.elapsed
      };
      return { type: 'landing', points };
    }
  }

  return null;
}
